<template>
  <div>
    <!-- Loading -->
    <div class="flex-all-center" v-if="isLoadingRanking">
      <img src="../../../assets/images/loading.gif" alt="loading" />
    </div>
    <!-- 検索結果が0件 -->
    <div class="flex-all-center not-result" v-if="isNotFound">
      {{ Ranking.notFound[lang] }}
    </div>
    <!-- サーバーエラー -->
    <div class="flex-all-center not-result" v-if="isServerError">
      <span>
        {{ Ranking.failure[lang] }}
      </span>
      <button type="button" @click="emitRanking" class="button">
        {{ Ranking.update[lang] }}
      </button>
    </div>
    <!-- 見つかった件数 -->
    <div
      class="found"
      v-if="
        !isLoadingRanking &&
        !isNotFound &&
        !isServerError &&
        isInitialRankingData &&
        countTotalRunner
      "
    >
      {{ countTotalRunner }}{{ Ranking.hit[lang] }}
    </div>
    <!-- 完走証文言 -->
    <div
      v-if="!isLoadingRanking && !isNotFound && eventStatus === '0'"
      class="certificate-download flex-all-center"
    >
      {{ Ranking.certificateDescription[lang] }}
    </div>
  </div>
</template>

<script>
import Ranking from "../../../assets/constants/ranking/ranking.json";
export default {
  methods: {
    emitRanking: function () {
      this.$emit("initial-ranking");
    },
  },
  props: {
    isLoadingRanking: Boolean,
    isNotFound: Boolean,
    isServerError: Boolean,
    isInitialRankingData: Boolean,
    countTotalRunner: Number,
    eventStatus: String,
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  name: "Status",
};
</script>

<style scoped>
.not-result {
  margin: 0 0 100px 0;
  font-size: 24px;
  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 135px;
    height: 48px;
    margin: 0 0 0 12px;
    font-size: 16px;
    border: solid 1px #000;
    background-color: #fff;
    &:hover {
      color: #fff;
      background-color: #000;
    }
  }
}
.found {
  margin: 10px 0 0 0;
  font-size: 20px;
}
.certificate-download {
  margin: 10px 0 0 0;
  padding: 10px;
  background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ranking/Status.vue